import { makeStyles } from 'tss-react/mui';
import { COLORS } from '../../../constants/system/colors';

const useStylesHashtagItem: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  hashtagItem: {
    display: 'inline-flex',
    cursor: 'pointer !important',
    background: 'none !important',
    position: 'relative !important',
    margin: '5px 0 !important',
    wordBreak: 'break-word',
    whiteSpace: 'normal !important',
    hyphens: 'auto',
    '&:hover': {
      background: `${COLORS.infoLight} !important`,
    },
  },
}));

export default useStylesHashtagItem;
